import { render, staticRenderFns } from "./LaudoBacenResolucao.vue?vue&type=template&id=50f1955a&scoped=true&lang=pug"
import script from "./LaudoBacenResolucao.vue?vue&type=script&lang=js"
export * from "./LaudoBacenResolucao.vue?vue&type=script&lang=js"
import style0 from "./LaudoBacenResolucao.vue?vue&type=style&index=0&id=50f1955a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f1955a",
  null
  
)

export default component.exports